import { create } from "zustand";
import { useStudioStore } from "@/features/studio/state/studioStore";

/**
 * User menu (avatar drawer) — top-right.
 *
 * Mutex with `studioStore`: opening one closes the other so we never have
 * two drawers stacked on top-right. ESC closes either.
 */
interface UserMenuState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useUserMenuStore = create<UserMenuState>()((set, get) => ({
  isOpen: false,
  open: () => {
    // Mutex: close studio first
    useStudioStore.getState().close();
    set({ isOpen: true });
  },
  close: () => set({ isOpen: false }),
  toggle: () => {
    if (get().isOpen) {
      set({ isOpen: false });
    } else {
      useStudioStore.getState().close();
      set({ isOpen: true });
    }
  },
}));
